import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/workspaces/members';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

const unwrap = (res) => (res && res.data && res.data.data !== undefined ? res.data.data : (res && res.data) || {});

function* operation(action) {
  const { workspaceId } = action.payload;
  if (!workspaceId) return;
  try {
    const res = yield call(
      axios.get,
      `${config.API_URL}/workspace/${workspaceId}/members`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(unwrap(res)));
  } catch (err) {
    yield put(ErrorAction(err));
    const message = err?.response?.data?.message || 'Could not load members';
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message });
    yield put(fetchFailure(message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
